import { Component, OnInit } from '@angular/core';
import { AddNewManagers, AgenciesForManagers } from '../Models/AgencyMasterProperties';
import { AgencyService } from '../Services/Agency.service';
import { ActiveSuppliers, ParentUsers } from '../Models/ActiveClasses';
import { RevenueManagementService } from '../Services/revenue-management.service';
import { TicketSuppliersAccessCodeProperties } from '../Models/GroupTicketProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { SuppliersService } from '../Services/suppliers.service';
import { Router } from '@angular/router';
import { AgencySuppliers } from '../Models/OfflineBookingRequestProperties';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-suppliers',
  templateUrl: './add-suppliers.component.html',
  styleUrls: ['./add-suppliers.component.css']
})
export class AddSuppliersComponent implements OnInit {
  agencyList: AgenciesForManagers[] = [];
  supplierList: ActiveSuppliers[] = [];
  officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  officeidList: TicketSuppliersAccessCodeProperties[] = [];
  officeid: string = "";
  SuppliersSubmitted: boolean = false;
  managersList: ParentUsers[] = [];
  loaderVar: boolean = false;
  loader: boolean = false;
  supplierAdded: boolean = false;
  newobj = new AgencySuppliers();
  constructor(private messageService: MessageService,private agencyService: AgencyService, private revenueService: RevenueManagementService, 
    private groupservice: GroupTicketService, private supplierService: SuppliersService,
    private router: Router) { }

  ngOnInit() {
    this.getSuppliers();
    this.GetAgencysList();
  }
  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;
    });
  }
  changeSupplier(supplier) {

    this.officeidListForBind = [];
    this.officeidList = [];
    this.groupservice.GetTicketAccessCode(supplier).subscribe(data => {
      this.officeidListForBind = data;
      this.supplierAdded = true;
    });

  }
  
  private GetAgencysList = (): void => {
    let userId: number = 0;
    this.agencyService.GetAgenciesForSupplierManagers(userId, localStorage.getItem("AgencyId")).subscribe(data => {
      this.agencyList = data;
      let agency = new AgenciesForManagers();
      agency.agencyId = "All";
      agency.agencyName = "All";
      this.agencyList.splice(0, 0, agency);
    });
  }
  public SelectedAgencies = (): void => {
    if (this.newobj.agencyIds.includes("All")) {
      this.newobj.agencyIds =this.agencyList.map(agency => {
        return agency.agencyId
      });
      this.newobj.agencyIds.shift();
    }
    else {
      this.agencyList = this.agencyList.map(agency => {
        return { ...agency, disabled: false }
      });
    }
  }
  public SaveManagers = (SupplierForm: any): boolean => {
    this.SuppliersSubmitted = true;
    if (!SupplierForm.valid) {
      return false;
    }
    else {
      this.loader = true;
      this.newobj.creationUser = Number(localStorage.getItem('UserId'));
      this.supplierService.CreateAgencySupplier(this.newobj).subscribe(data => {
        this.loader = false;
        if (data) {
          this.messageService.add({ severity: 'success', summary: 'Successfully!', detail: "Assigned!" });

        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: "Please Try Again!" });

        }
      });
      document.getElementById("managers_submit").setAttribute('disabled', 'disabled');
    }
    this.supplierAdded= true;
  }
}
